import { ServiceTypeEnum } from '@sr-sdks/api-sdk-axios';
import { ScopedStatementsPage } from './ScopedStatementsPage';

export const RESIDUAL_SERVICE_TYPES = [ServiceTypeEnum.Residuals];

export const Residuals = () => (
  <ScopedStatementsPage
    title="Residuals"
    csvFileLabel="residuals"
    paginationKey="residualsStatementsTablePage"
    serviceTypes={RESIDUAL_SERVICE_TYPES}
  />
);
